export const pillars = [
  {
    title: 'Le bien-être au naturel',
    text: 'Des ingrédients jusqu’au packaging, nous garantissons une qualité optimale et un respect de la nature.',
  },
  {
    title: 'Aloe vera d’Andalousie',
    text: 'La plante est cultivée de manière éco-responsable proche de chez nous, en Espagne, ce qui limite l’empreinte carbone.',
  },
  {
    title: 'En pharmacie',
    text: 'Retrouvez nos produits en pharmacie et parapharmacie, au plus près de chez vous.',
  },
];
